import { ModuleGroup, useModules } from 'api/modules/modules.api'
import { useMemo } from 'react'
import { Module } from 'types/modules'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import { RoutesArray } from 'ui/components/Navigation/types'

export const filterRoutes = (routes: RoutesArray, modules: ModuleGroup[]): RoutesArray => {
  const moduleNames = modules.map((item) => item.name)

  /**
   *  Filters routes, if only one child exists it should not be nested
   */
  const routesWithPossibleChildren: RoutesArray = []
  routes.forEach((item) => {
    let possibleChildren
    if (item.children) {
      possibleChildren = item.children.filter((child) => child.module && moduleNames.includes(child.module))
      if (possibleChildren.length === 1) {
        routesWithPossibleChildren.push({
          ...possibleChildren[0],
          sidebarName: possibleChildren[0].sidebarName,
        })
      } else if (possibleChildren.length > 0) {
        routesWithPossibleChildren.push(
          Object.assign({}, item, {
            children: possibleChildren,
          })
        )
      }
    } else {
      routesWithPossibleChildren.push(item)
    }
  })

  const filteredRoutes = routesWithPossibleChildren.filter(
    (item) =>
      item.children || item.alwaysAvailable || (item.module && moduleNames.includes(item.module)) || item.globalModule
  )

  return filteredRoutes
}

export const useModuleIsActivatedOnSystem = (moduleName: Module | undefined): boolean => {
  const auth = useAuth()
  const { data: modules = [] } = useModules(auth.systemId)

  const isActiveForSystem = useMemo(() => {
    if (moduleName === undefined) {
      return false
    }
    const module = modules.find((m) => m.name === moduleName)
    return !!module?.is_active_for_system
  }, [modules, moduleName])

  return isActiveForSystem
}
